export default __webpack_public_path__ + "static/media/zbp_select_fund_icon.0b25394b.svg";